import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Fahrzeugdaten.Kennzeichen
 * Kennzeicheninformationen
 * Endpoints: /api/Garage/{id}, /api/Garage
 */
export class KennzeichenApi extends BaseApiModel {
	constructor(initialProperties?: Partial<KennzeichenApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected kreis: string;
	/**
	 * Description: Kreiszeichen (evtl. Enum)
	 * APIL Type: string
	 */
	get Kreis(): string {
		return this.kreis;
	}

	/**
	 * Description: Kreiszeichen (evtl. Enum)
	 * APIL Type: string
	 */
	set Kreis(value: string) {
		this.kreis = value;
	}

	protected nummer: string;
	/**
	 * Description: Kennzeichen-Nummer (Buchstaben-Zahlenkombi) optional
	 * APIL Type: string
	 */
	get Nummer(): string {
		return this.nummer;
	}

	/**
	 * Description: Kennzeichen-Nummer (Buchstaben-Zahlenkombi) optional
	 * APIL Type: string
	 */
	set Nummer(value: string) {
		this.nummer = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): KennzeichenApi {
		return AppUtils.Helper.createFromMap(dataObject, KennzeichenApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Kreis = this.kreis;
		result.Nummer = this.nummer;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}